import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-lg-8 mb-0 mb-md-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, "Produkter"),
    /*#__PURE__*/_createElementVNode("p", { class: "lead text-center" }, "Vårt fokus ligger på hållbara bruksknivar med smarta fodral, utrustade med de senaste fäst- och bärsystemen. Vi säkerställer kvalitet och exklusivitet genom att skapa egna designer och göra alla arbeten omsorgsfullt för hand. På så vis vet vi att våra produkter både motsvarar dina förväntningar och håller en livstid. För dig som söker det verkligt speciella erbjuder vi möjligheten att skapa en kniv helt efter din ide och på dina villkor, med vår kvalitetsstämpel.")
  ])
], -1)

import { onMounted } from 'vue';
    import AboutUs from '@/components/AboutUs.vue';
    import Video from '@/components/Video.vue';
    import Categories from '@/components/Categories.vue';
    import { useMeta } from '@/composables/meta';
    import { useCanonical } from '@/composables/canonical';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Start',
  setup(__props) {

    onMounted(async () => {
        useMeta('', 'Upptäck vårt handgjorda sortiment av knivar och skräddarsydda knivfodral. Köp unika och pålitliga verktyg för dina äventyr direkt från vår hemsida.');
        useCanonical('');
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Video)
    ]),
    _createVNode(AboutUs),
    _hoisted_3,
    _createVNode(Categories)
  ]))
}
}

})